<template>
  <div>
    <img
      v-if="ttd"
      :src="$store.getters.getBaseUrl + '/api/file/' + ttd.ttd"
      class="mb-3"
      width="200"
    >
    <img
      v-else
      :src="require('@/assets/stisla/img/news/img01.jpg')"
      class="mb-3"
      width="200"
    >
    <br>
    <button
      class="btn btn-primary btn-sm"
      @click="showModalTtd"
      type="button"
    >
      {{ (ttd) ? 'Ubah tanda tangan digital' : 'Buat tanda tangan digital' }}
    </button>

    <b-modal
      hide-footer
      id="modal-ttd"
      title="Tanda Tangan Digital"
      size="lg"
    >
      <b-tabs content-class="mt-3">
        <b-tab
          title="Gambar"
          active
        >
          <div>
            <div style="width: 300px; margin: 0 auto">
              <canvas
                id="canvas-ttd"
                style="border: 1px solid #aaa"
              />
            </div>
            <div class="text-center">
              <button
                @click="signaturePadClear"
                class="btn btn-danger btn-sm m-1"
              >
                <i class="fa fa-times pr-2" />Hapus
              </button>
              <button
                id="btnSimpanDrawTtd"
                class="btn btn-primary btn-sm m-1"
                @click="signaturePadSave"
              >
                <i class="fa fa-check pr-2" />Simpan
              </button>
            </div>
          </div>
        </b-tab>
        <b-tab title="Upload">
          <form
            action=""
            method="POST"
            @submit="onSubmit"
          >
            <div class="form-group">
              <div class="input-group">
                <input
                  type="file"
                  class="form-control"
                  accept="image/png"
                  @change="setFile"
                >
                <div class="input-group-append">
                  <button
                    id="btnUploadTtd"
                    class="btn btn-primary"
                    type="submit"
                  >
                    <i class="fa fa-upload pr-2" />Upload
                  </button>
                </div>
              </div>
            </div>
          </form>
          <img
            v-if="preview != ''"
            :src="preview"
          >
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import swal from 'sweetalert'
import SignaturePad from 'signature_pad'

export default {
    data() {
        return {
            form: {
                file: ''
            },
            preview: '',
            signaturePad: ''
        }
    },
    computed: {
        profile(){
            return this.$store.getters.getUserProfile
        },
        ttd(){
            return this.$store.getters.getTtdUser
        }
    },
    methods: {
        onSubmit(e){
            e.preventDefault()

            this.saveTtd('#btnUploadTtd')
        },
        saveTtd (buttonEl) {
            if(this.form.file === ''){
                swal({
                    title: "Kesalahan",
                    text: "Pilih gambar tanda tangan digital",
                    icon: "error",
                    buttons: "Ok"
                })
                return false
            }

            let button = document.querySelector(buttonEl)
            let buttonHtml = button.innerHTML

            button.setAttribute('disabled', true)
            button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>'

            let form = new FormData
            form.append('file', this.form.file, 'image.png')

            let dispatch = 'storeUserTtd'
            let dataDispatch = form

            if(this.ttd){
                // update
                dispatch = 'updateUserTtd'
                dataDispatch = {
                    id: this.profile.id_penduduk,
                    form: form
                }
            }
            
            this.$store.dispatch(dispatch, dataDispatch).then(res => {
                button.removeAttribute('disabled')
                button.innerHTML = buttonHtml
                if(res.data.status){
                    this.$store.dispatch('setUserTtd', res.data.data)
                }
                this.preview = ''
                this.form.file = ''
                this.$bvModal.hide('modal-ttd')
            })
        },
        setFile(e){
            this.form.file = e.target.files[0]
            this.preview = URL.createObjectURL(this.form.file);
        },
        showModalTtd () {
          this.$bvModal.show('modal-ttd')
          setTimeout(() => {
            const canvas = document.querySelector('#canvas-ttd')
            this.signaturePad = new SignaturePad(canvas)
          }, 500)
        },
        signaturePadSave () {
          if (this.signaturePad.isEmpty()) {
            swal({
                title: "Kesalahan",
                text: "Tidak ada gambar",
                icon: "error",
                buttons: "Ok"
            })
            return false
          }
          const ttdImage = this.signaturePad.toDataURL('image/png')
          
          this.form.file = this.dataURIToBlob(ttdImage)
          // this.form.file = ttdImage
          
          this.saveTtd('#btnSimpanDrawTtd')
        },
        dataURIToBlob(dataURI) {
          const splitDataURI = dataURI.split(',')
          const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
          const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

          const ia = new Uint8Array(byteString.length)
          for (let i = 0; i < byteString.length; i++)
              ia[i] = byteString.charCodeAt(i)

          return new Blob([ia], { type: mimeString })
        },
        signaturePadClear () {
          this.signaturePad.clear()
        }
    },
    created(){
        this.$store.dispatch('fetchUserTtd').then(res => {
            if(res.data.status){
                this.$store.dispatch('setUserTtd', res.data.data)
            }
        })
    }
}
</script>
